import { signal } from "@preact/signals";

/**
 * "I'm 16 or older" (ADR 0025): asked once per browser before a first game, then remembered.
 * Without storage (private windows, blocked site data) it holds for this page's life.
 */
export const AGE_KEY = "obean.age16";

function read(): boolean {
  try {
    return localStorage.getItem(AGE_KEY) === "yes";
  } catch {
    return false;
  }
}

/** Whether this browser has said it's 16 or older. */
export const ageConfirmed = signal(read());

export function confirmAge(): void {
  try {
    localStorage.setItem(AGE_KEY, "yes");
  } catch {
    // Not stored: asked again next visit.
  }
  ageConfirmed.value = true;
}
